module.exports = __webpack_public_path__ + "static/media/OrderCircle.e193a161.svg";